import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import WisetackAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/WisetackAppIcon';

import { WISETACK } from '../../../../Resources/ConsumerLending/Lenders/Data';
import Spacer20 from '../../../Misc/Spacer20.js';
import WisetackToggleAndButton from '../OtherComponents/WisetackToggleAndButton';

const WisetackStrategy = {
  previewInfo: {
    name: WISETACK,
    iconSvg: <WisetackAppIcon size="jumbo" />,
  },
  headerInfo: {
    name: WISETACK,
    category: 'Increase ticket sizes by offering financing options to your customers',
    details: (
      <div>
        Wisetack makes it easy for your customers to pay over time for their purchases. Close more sales & get paid
        within days, while allowing your customers to get instant decisions with great rates.
        <Spacer20 />
        For you: financing options are integrated into your Housecall Pro estimates and invoices. If a customer pays
        using financing, that payment goes directly into your bank account - there are no additional credit card fees.
        No one-time fees or monthly minimums, either.
        <Spacer20 />
        For your customer: there are no origination fees, prepayment penalties, deferred interest, or other tricks. Our
        goal is to make financing as simple and straightforward as possible. Terms up to 60 months.
        <Spacer20 />
        Once enabled, financing will be offered on every estimate and invoice between $500-$25,000.
        <Spacer20 />
        More questions? See{' '}
        <a href="https://www.wisetack.com/housecallpro" target="_blank" rel="noreferrer">
          https://www.wisetack.com/housecallpro
        </a>{' '}
        for more information
        <Spacer20 />
        **Integration not currently available through Housecall Pro in Canada. Some eligibility criteria may apply.
      </div>
    ),
    iconSvg: <WisetackAppIcon size="jumbo" />,
  },
  media: {
    wistiaLink: 'https://fast.wistia.net/embed/iframe/ak50b8tmn0',
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    hideToggle: true,
    title: 'Housecall Pro Add-on Price',
    appActionButton: <WisetackToggleAndButton />,
    description: (
      <Typography variant="body1" color="textSecondary">
        3.9% fee per transaction. There are no subscription or credit card processing fees on top of that.
      </Typography>
    ),
  },
  supportContacts: [
    { type: 'Email', contact: 'support@wisetack.com' },
    { type: 'Phone', contact: '833-927-0333' },
    {
      type: 'Website',
      contact: (
        <a href="https://www.wisetack.com" target="_blank" rel="noreferrer">
          www.wisetack.com
        </a>
      ),
    },
  ],
};

export default WisetackStrategy;
